import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { RestService } from '../../../../services/rest/rest.service';
import {
  TransferUapmResponse,
  TransferInResponse
} from './security-options.domain';

@Injectable()
export class SecurityOptionsRestService {

  constructor(private restService: RestService) {
  }

  transferUapm(hash: string): Observable<TransferUapmResponse> {
    const parameters = {
      params: {
        hash
      }
    };
    return this.restService.getResource('transfer.uapm')
      .post(undefined, parameters);
  }

  // Backend prefers to have separate endpoints
  transferEasyApply(): Observable<TransferInResponse> {
    return this.restService.getResource('transfer.easyapply').post(undefined);
  }
}

